import { Props_SnippetAccordion } from "./Accordion.props";

const Accordion = (props: Props_SnippetAccordion ) => {
    const { accordionTitle, repeatable_accordionRow } = props;

    const accordionTitleTitleClass = "snippet-accordion__title " + (accordionTitle?.showTitle?.value === "true" ? "" : "accessible-heading");

    return (
        <section className="snippet-accordion">
            <div className="snippet-accordion__container">
               {accordionTitle?.text?.value && <h2 className={accordionTitleTitleClass}>
                    {accordionTitle.text.value}
                </h2>}

                <div className="snippet-accordion__row-container">
                    {repeatable_accordionRow.map((accordionRow, index) => (
                            <details
                                key={"accordion-row-" + index}
                                className="snippet-accordion__row"
                                name="accordion-row"
                            >
                               { accordionRow?.title?.value && <summary className="snippet-accordion__row-title">
                                    {accordionRow.title.value}
                                </summary> }
                                <div className="snippet-accordion__content-container">
                                   { accordionRow?.text?.value && <p className="snippet-accordion__text">
                                        {accordionRow.text.value}
                                    </p> }
                                   { accordionRow?.linkhref?.value && accordionRow?.linktext?.value && <a
                                        href={accordionRow.linkhref.value}
                                        className="snippet-accordion__link outline-button-white"
                                        aria-label={accordionRow.linktext.value}
                                    >
                                        {accordionRow.linktext.value}
                                    </a>}
                                </div>
                            </details>
                        
                    ),)}
                </div>
            </div>
        </section>
    );
};

export default Accordion;
